import React from 'react';
import cx from 'classnames';
import BaseForm from '../../../../../components/form/BaseForm';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import OpenOrderItemDetail from '../../../../../components/link/OpenOrderItemDetail';
import OpenOrderModifyDeliveryInfo from '../../../../../containers/app/common/OpenOrderModifyDeliveryInfo';
import { setDash } from '../../../../../lib/common';
import './CheckDeliveryDispatchResultModal.scss';

const CheckDeliveryDispatchResultModal = (props) => {
  const { isOpen, data, onSubmit, closeModal } = props;
  const { deliveryInfoSummary, orderItemInfoList } = data;

  return (
    <Modal
      title="배송지 변경 이력"
      isOpen={isOpen}
      width={1000}
      isFooter={true}
      okText="발송 처리"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="check-delivery-dispatch-result-modal-wrap">
        <div className="check-delivery-dispatch-result-summary">
          <BaseForm
            className="dispatch-request-cnt"
            label="발송 처리 요청 개수"
            content={deliveryInfoSummary.requestCnt}
          />

          <BaseForm
            className="modify-delivery-cnt"
            label="배송지 변경 이력 있는 주문건 수"
            content={deliveryInfoSummary.modifyCnt}
          />
        </div>

        {deliveryInfoSummary.modifyCnt ? (
          <div className="check-delivery-dispatch-result-info">
            <div className="emphasize">배송지 변경 이력이 있는 주문서가 있습니다.</div>
            <div className="emphasize">
              입력하신 송장번호가 최근에 변경된 주소와 동일한지 확인 후 발송 처리 해주세요.
            </div>
          </div>
        ) : null}

        <InfoTable>
          <thead>
            <tr>
              <th>배송지 변경이력</th>
              <th>주문 번호</th>
              <th>상품 주문 번호</th>
              <th>상품명</th>
              <th>옵션정보</th>
              <th>배송지</th>
              <th>우편번호</th>
            </tr>
          </thead>

          <tbody>
            {orderItemInfoList.map((item, index) => (
              <tr key={index} className={cx({ 'is-modify': item.orderItemModifyId })}>
                <td className="tc">
                  {item.orderItemModifyId ? <OpenOrderModifyDeliveryInfo orderItemId={item.orderItemId} /> : '-'}
                </td>
                <td className="tc">{item.orderId}</td>
                <td className="tc">
                  <OpenOrderItemDetail text={item.orderItemId} orderItemId={item.orderItemId} />
                </td>
                <td className="tc">{item.productName}</td>
                <td className="tc">{setDash(item.productOption)}</td>
                <td className="tc">{item.shippingAddress}</td>
                <td className="tc">{item.shippingPostCode}</td>
              </tr>
            ))}
          </tbody>
        </InfoTable>
      </div>
    </Modal>
  );
};

export default CheckDeliveryDispatchResultModal;
